(ns app.front.view.application-wizard.authority-create
  (:require [app.front.ui :as ui]
            [app.front.ui.radio :as ui-radio]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]))

(def default-authority-create-mode :application-wizard.authority-create-mode/default)

(def without-party-authority-create-modes
  #{:application-wizard.authority-create-mode/behalf-of-customer
    :application-wizard.authority-create-mode/submitted-earlier})

(defn manual-submit-date-valid? [date]
  (and date (date-util/on-or-before? date (date-util/now))))

(rf/reg-sub ::authority-create-mode
  (fn [db _]
    (get db ::authority-create-mode default-authority-create-mode)))

(rf/reg-event-db ::set-authority-create-mode
  (fn [db [_ value]]
    (let [mode (or value default-authority-create-mode)]
      (cond-> (assoc db ::authority-create-mode mode)
        (not= mode :application-wizard.authority-create-mode/submitted-earlier)
        (dissoc ::manual-submit-date)))))

(rf/reg-sub ::manual-submit-date
  :-> ::manual-submit-date)

(rf/reg-event-db ::set-manual-submit-date
  (fn [db [_ value]]
    (if value
      (assoc db ::manual-submit-date value)
      (dissoc db ::manual-submit-date))))

(rf/reg-sub ::authority-create-mode-ok?
  :<- [::authority-create-mode]
  :<- [::manual-submit-date]
  (fn [[mode date] _]
    (or (not= mode :application-wizard.authority-create-mode/submitted-earlier)
        (manual-submit-date-valid? date))))

(rf/reg-event-db ::cleanup
  (fn [db _]
    (dissoc db ::authority-create-mode ::manual-submit-date)))

(defn authority-create-application-data [db authority?]
  (let [mode (::authority-create-mode db default-authority-create-mode)]
    (when authority?
      (cond-> {}
        (contains? without-party-authority-create-modes mode)
        (assoc :create-without-party? true)

        (= mode :application-wizard.authority-create-mode/submitted-earlier)
        (assoc :submitted (::manual-submit-date db))))))

(defn submit-time-picker [tr]
  (let [submit-date (<sub [::manual-submit-date])
        submit-time (if submit-date
                      [(.getHours submit-date) (.getMinutes submit-date)]
                      [nil nil])]
    [:div.flex.flex-col.mt-6.mb-4.animation-appear-slide-down
     [:div.flex.flex-col.md:flex-row.items-end
      [ui/date-picker {:label-text (tr [:application-wizard/authority-create-submit-date])
                       :required?  true
                       :class-name "md:mr-2"
                       :max-date   (date-util/today-start-of-day)
                       :callback   #(when %
                                      (let [d (or submit-date (js/Date.))]
                                        (>evt [::set-manual-submit-date
                                               (date-util/set-hours-and-minutes % (.getHours d) (.getMinutes d))])))
                       :value      submit-date}]
      [ui/time-input {:label-text (tr [:application-wizard/authority-create-submit-time])
                      :required?  true
                      :class      "mt-2"
                      :on-change  (fn [[hour minute]]
                                    (>evt [::set-manual-submit-date
                                           (date-util/set-hours-and-minutes
                                             (or (date-util/start-of-day submit-date) (js/Date.))
                                             hour
                                             minute)]))
                      :value      submit-time}]]
     (when (and submit-date (date-util/after? submit-date (date-util/now)))
       [:div.bx--form-requirement.flex.max-h-full
        (tr [:application-wizard/authority-create-submit-date-future])])]))

(defn selector [tr]
  (let [value (<sub [::authority-create-mode])]
    [:div.p-4.border-t.border-solid.border-gray-300
     [:h4.mb-4 (tr [:application-wizard/authority-create-title])]
     [ui-radio/radio {:name       "authority-create-mode"
                      :class-name "flex-wrap"
                      :values     [default-authority-create-mode
                                   :application-wizard.authority-create-mode/behalf-of-customer
                                   :application-wizard.authority-create-mode/submitted-earlier]
                      :value      value
                      :val->str   (comp tr vector)
                      :on-change  #(>evt [::set-authority-create-mode %])}]
     (when (= value :application-wizard.authority-create-mode/submitted-earlier)
       [submit-time-picker tr])]))
